<template>
	<v-btn v-if="isLargeButton" @click.stop="downloadOrViewAttachment()" small outlined :disabled="attachment_downloading" :loading="selfloading">
		{{ computedLabel }}
		<v-icon small class="pl-1">{{ computedIcon }}</v-icon>
	</v-btn>
	<v-btn v-else icon small @click.stop="downloadOrViewAttachment()" color="primary" :disabled="attachment_downloading" :loading="selfloading">
		<v-icon>{{ computedIcon }}</v-icon>
	</v-btn>
</template>

<script>
export default {
	data: () => ({
		selfloading: false,
	}),
	props: {
		element: {
			type: Object,
			default: {},
		},
		action: {
			type: String,
			default: "view",
		},
	},
	computed: {
		computedIcon() {
			if (this.action == "download") {
				return "fas fa-download";
			}
			return this.$functions.iconFromFileType(this.element.filetype);
		},
		computedLabel() {
			if (this.isLargeButton) {
				return this.$t("attachment.download");
			}
			return null;
		},
		attachment_downloading() {
			return this.$store.getters.attachment_downloading;
		},
		isDownloadAction() {
			if (this.action == "download") {
				return true;
			}
			return false;
		},
		isLargeButton() {
			if (this.isDownloadAction) {
				return true;
			}
			return false;
		},
	},
	methods: {
		downloadOrViewAttachment() {
			const self = this;
			if (this.element.link && this.action == "view") {
				this.$functions.openLink(this.element.link);
			} else {
				this.$functions.openLink(this.element.link, "download", this.element.filename);
			}
		},
	},
};
</script>
